<!--
 * @Author: 羊驼
 * @Date: 2023-10-27 16:15:23
 * @LastEditors: 羊驼
 * @LastEditTime: 2023-10-31 14:45:43
 * @Description: file content
-->
<template>
  <div id="app2">
    <!-- <el-upload
      class="upload-demo"
      action="https://jsonplaceholder.typicode.com/posts/"
      :auto-upload="false"
      :limit="1"
      :on-change="initModel"
      accept=".fbx"
      :show-file-list="false"
    >
      <el-button size="small" type="primary">点击上传模型文件</el-button>
    </el-upload> -->
    <fbx-viewer :type="type" :url="urled"  ref="model" v-if="showed" />
  </div>
</template>

<script>
import FbxViewer from "./FbxViewer2.vue";
import axios from "axios";
export default {
  components: { FbxViewer },
  name: "App",
  data() {
    return {
      showed:false,
      urled:'static/fbx/水泵.fbx',
      aa: "static/fbx/111.gltf",
      type: "gltf",
      file: null,
      fileData: {
        status: "ready",
        name: "222.fbx",
        size: 282000,
        percentage: 0,
        uid: 1723108970683,
        raw: {
          uid: 1723108970683,
        },
      },
    };
  },
  computed: {
    memo() {
      return this.$store.menuStore.state.nowMenu.memo;
    },
  },
  mounted() {
    // this.urled=this.memo || 'static/fbx/设备层3ds.3DS'
    this.showed=true;
    this.$nextTick(() => {
          this.$refs.model.init();
        });
  },
  methods: {
    aaa(v) {
      var fileInput = document.getElementById("fileInput");
      var selectedFile = fileInput.files[0];

      v.preventDefault();
      return;
      axios({
        url: "/api/ExcelReport/GetExcelTemplateBuildFileXlsx",
        method: "post",
        data: "",
        responseType: "arraybuffer",
      })
        .then(function(response) {})
        .catch((err) => {});
    },
    initModel(file) {
      if (file != this.file) {
        this.file = file;
        this.$nextTick(() => {
          this.$refs.model.init();
        });
      }
    },
  },
};
</script>

<style>
#app2 {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
